import moment from 'moment';
import { envApiConfig } from './components/shared/Links';

export const matchPathname = (pathsList) => pathsList.filter(p => window.location.pathname === p);

// Read MGP iframe
export const iframeMGP = document.getElementsByName('mgp_iframe');

// Util function to Set / Reset Session Timer based on user activity
export const setLastRequestTime = () => { localStorage.setItem('lastRequestTime', moment().format('x')); if (iframeMGP.length) {iframeMGP[0].contentWindow.postMessage(JSON.stringify({ resetSessionTimeout: true }), '*')} };

// Util function to Set / Reset MGP Session Timer based on user activity
export const resetMGPSessionTimer = () => iframeMGP.length ? iframeMGP[0].contentWindow.postMessage(JSON.stringify({ resetSessionTimeout: true }), '*') : null;

// Set if modal is open
export const setSTModalActive = () => localStorage.setItem('sTMActive', 'open');

// To read if modal is open
export const getSTModalActive = () => localStorage.getItem('sTMActive') || null;

// To remove modal state from localStorage
export const removeSTModalActive = () => localStorage.removeItem('sTMActive');

export const isJson = (jsonObject) => {
    let item;
    try {
        item = JSON.parse(jsonObject);
    } catch (e) {
        return false;
    }

    return (typeof item === "object" && item !== null);
};

export const closeModal = (id) => {
    const modal = document.getElementById(id);
    if (modal && modal.open) {
        modal?.close();
    }
};

export const showModal = (id) => {
    setTimeout(() => {
        const modal = document.getElementById(id);
        if (modal && modal?.open === false) {
            try {
                modal?.show()
            } catch (e) {
                log(console.log(e));
            }
        }
    }, 100)
}

let appEnvironment = null;

async function getEnvironmentFromConfigs() {
    const response = await fetch(envApiConfig, {});
    const json = await response.json();

    if (json && json.environment) {
        appEnvironment = json.environment;
        return json.environment
    } else {
        appEnvironment = 'localhost';
        return 'localhost'
    }
}

let functionHasRun = false;

export async function log(children) {

    if (appEnvironment === null && !functionHasRun) {
        functionHasRun = true;
        await getEnvironmentFromConfigs()
            .then(response => response !== 'prod' ? {children} : null)
    }

    if(appEnvironment !== 'prod' && appEnvironment !== null) {
        return {children}
    }

    return null;
}
